import { BasePropertyDTO, EnumElementDTO, ListElementDTO } from 'business/models/Models';
import { systemPropertiesCache } from 'generic/systemPropertiesCache';
import { useEffect, useState } from 'react';

type PropertyValueType<T> = T extends { value?: infer V } ? V : never;

export function useSystemProperty<T extends BasePropertyDTO & { value?: any }>(
  name: string,
  defaultValue: PropertyValueType<T>,
): PropertyValueType<T> {
  const [value, setValue] = useState<PropertyValueType<T>>(defaultValue);

  useEffect(() => {
    let mounted = true;
    systemPropertiesCache.get(name).then((v) => {
      if (!mounted || !v) {
        return;
      }
      const value = (v as T).value;
      if (value instanceof EnumElementDTO) {
        setValue((value as EnumElementDTO).displayName as PropertyValueType<T>);
      } else if (value instanceof ListElementDTO) {
        setValue((value as ListElementDTO).name as PropertyValueType<T>);
      } else {
        setValue(value as PropertyValueType<T>);
      }
    });
    return () => {
      mounted = false;
    };
  }, [name]);

  return value;
}
